if (!customElements.get('larbre-review-highlights')) {
  customElements.define('larbre-review-highlights', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      // Their widget (Loox) is a scroll-snap row: every card full width, 12px apart, and the arrows slide one card
      // with a smooth scroll (~400ms); phones swipe. The markup ships the cards hidden but the first, so without
      // this script one card still shows.
      this.cards = [...this.querySelectorAll('[data-review-id]')];
      this.track = this.querySelector('.lrh__slides');
      this.cards.forEach(card => { card.hidden = false; });
      this.classList.add('lrh--row');
      this.index = 0;
      this.previous = this.querySelector('.lrh__previous');
      this.next = this.querySelector('.lrh__next');
      this.updateArrows();
      this.track.addEventListener('scroll', () => {
        const step = this.cards[0].offsetWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        this.index = Math.max(0, Math.min(this.cards.length - 1, Math.round(this.track.scrollLeft / step)));
        this.updateArrows();
      }, { passive: true, signal: this.controller.signal });
      this.querySelectorAll('[data-step]').forEach(button => {
        button.addEventListener('click', () => {
          const index = Math.max(0, Math.min(this.cards.length - 1, this.index + Number(button.dataset.step)));
          const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollTo({ left: this.cards[index].offsetLeft - this.cards[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          this.index = index;
          this.updateArrows();
          if (button.hidden && document.activeElement === button) {
            (button === this.next ? this.previous : this.next).focus({ preventScroll: true });
          }
        }, { signal: this.controller.signal });
      });
      this.addEventListener('click', async event => {
        const card = event.target.closest('[data-review-id]');
        if (!card || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const reviews = document.querySelector('larbre-product-reviews');
        if (!reviews?.load) return; // The anchor still works without the full widget's JS.
        event.preventDefault();
        if (this.opening) return;
        this.opening = true;
        try {
          if (!await reviews.load() || !this.isConnected) {
            if (this.isConnected) reviews.scrollIntoView({ block: 'start' });
            return;
          }
          let index = reviews.filtered.findIndex(row => row.id === card.dataset.reviewId);
          if (index < 0) {
            reviews.rating = null;
            reviews.filterAndRender();
            index = reviews.filtered.findIndex(row => row.id === card.dataset.reviewId);
          }
          if (index >= 0) reviews.showReview(index, card);
          else reviews.scrollIntoView({ block: 'start' });
        } finally { this.opening = false; }
      }, { signal: this.controller.signal });
    }
    updateArrows() {
      this.previous.hidden = this.index === 0;
      this.next.hidden = this.index >= this.cards.length - 1;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
